import { debounce } from 'debounce';

document.addEventListener('DOMContentLoaded', () => {
  // Get all "navbar-burger" elements
  const jQuerynavbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if (jQuerynavbarBurgers.length > 0) {

    // Add a click event on each of them
    jQuerynavbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const jQuerytarget = document.getElementById(target);
        const jQueryhtml = document.getElementsByTagName('html')[0];
        const jQueryheader = document.getElementsByTagName('header')[0];

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        jQuerytarget.classList.toggle('is-active');
        jQueryhtml.classList.toggle('is-used');
        jQueryheader.classList.toggle('menu-opened');
      }, {passive: true});
    });
  }

  window.onscroll = debounce(sticky, 50);
  function sticky(e) {
    if (window.pageYOffset > 1) {
      if (document.querySelector('.path-frontpage header')) {
        document.querySelector('.path-frontpage header').classList.remove('is-front-header');
      }
    }
    else {
      if (document.querySelector('.path-frontpage header')) {
        document.querySelector('.path-frontpage header').classList.add('is-front-header');
      }
    }

    if (window.pageYOffset > 1) {
      document.querySelector('header').classList.add('fixed');
    }
    else {
      document.querySelector('header').classList.remove('fixed');
    }
  }

  let agentInputs = document.querySelectorAll('.search-with-code input');

  if (agentInputs.length > 0) {
    agentInputs.forEach(el => {
      const isEmpty = str => !str.trim().length;

      var redirectFunction = function(e) {
        if (isEmpty(el.value)) {
          el.parentElement.querySelector('svg').classList.remove('has-value');

          el.parentElement.querySelector('svg').addEventListener('click', (event) => {
            event.preventDefault();
          })
        }
        else {
          el.parentElement.querySelector('svg').classList.add('has-value');
          let inputValue = el.value;
          let language = drupalSettings.path.currentLanguage;

          let url = 'https://' + window.location.hostname + '/' + language;
         // url = (language === 'el') ? url : url + '/' + language;

          if(e.which === 10 || e.which === 13) {
            window.location.href = url + '/search?bundle_of_properties=all&payment_option=*&agent_id=' + inputValue + '&lang=' + language;
          }

          el.parentElement.querySelector('svg').addEventListener('click', (event) => {
            window.location.href = url + '/search?bundle_of_properties=all&payment_option=*&agent_id=' + inputValue + '&lang=' + language;
          })
        }
      }

      window.addEventListener('keyup', redirectFunction, false);
      window.addEventListener('keydown', redirectFunction, false);
      window.addEventListener('focus', redirectFunction, false);
    });
  }

  let header = document.querySelector('header.is-front-header');

  if (header) {
    header.addEventListener("mouseenter", function( event ) {
      if (document.querySelector('header:not(.fixed)')) {
        header.classList.remove('is-front-header');
      }

    }, false);

    header.addEventListener("mouseleave", function( event ) {
      if (document.querySelector('header:not(.fixed)')) {
        header.classList.add('is-front-header');
      }
    }, false);
  }


  //if url param contains agent_id, we will scroll to results area
  const searchParams = new URLSearchParams(window.location.search);
  if(searchParams.has('agent_id')){
    const resultsArea = document.getElementById('houseRecords');
    resultsArea.scrollIntoView({behavior: 'smooth'}, true);
  }






}, {passive: true});
